var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.81,
    height: 21.056,
    viewBox: "0 0 22.81 21.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(357 -183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(-357 183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_781",
    "data-name": "Caminho 781",
    d: "M124.39,466.533H114.33A1.3,1.3,0,0,1,113,465.173q0-7.662,0-15.324c0-1.014,0-2.029,0-3.043a1.3,1.3,0,0,1,1.337-1.328q10.088,0,20.176,0a1.3,1.3,0,0,1,1.292,1.317q.005,3.947,0,7.895,0,5.208,0,10.417a1.31,1.31,0,0,1-1.433,1.425H124.39Zm10.536-16.651H113.879c0,.073-.008.127-.008.181q0,7.511,0,15.021c0,.416.16.569.588.569h19.818c.513,0,.647-.135.647-.65q0-6.908,0-13.815C134.927,450.759,134.927,450.331,134.927,449.882Zm-21.053-.914h21.053c0-.648,0-1.278,0-1.907,0-.593-.111-.7-.7-.705l-15.9,0q-1.946,0-3.892,0c-.359,0-.554.149-.559.458C113.866,447.526,113.874,448.238,113.874,448.969Z",
    transform: "translate(-112.994 -445.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_782",
    "data-name": "Caminho 782",
    d: "M137.617,497.979h6.49c.453,0,.588.137.588.6q0,4.3,0,8.6c0,.425-.141.569-.559.569l-13.091,0c-.407,0-.554-.145-.554-.546q0-4.341,0-8.681c0-.4.151-.543.558-.543h6.573Zm6.17,8.866v-7.958h-12.4v7.958Z",
    transform: "translate(-128.711 -492.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_783",
    "data-name": "Caminho 783",
    d: "M197.928,609.141c-.434,0-.839,0-1.244,0-.347,0-.539-.169-.532-.458s.193-.428.531-.43c.4,0,.809,0,1.243,0,0-.174-.007-.319,0-.464a.415.415,0,0,1,.423-.423q.9-.012,1.8,0a.419.419,0,0,1,.434.441c.006.137,0,.274,0,.444h.7c.638,0,1.276,0,1.914,0a.445.445,0,1,1,0,.884c-.859,0-1.718,0-2.616,0,0,.159.005.3,0,.447a.416.416,0,0,1-.435.439q-.888.012-1.775,0a.423.423,0,0,1-.449-.455C197.924,609.441,197.928,609.312,197.928,609.141Zm.9-.023h.865v-.85h-.865Z",
    transform: "translate(-187.866 -591.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_784",
    "data-name": "Caminho 784",
    d: "M281.488,497.973c.563,0,1.127,0,1.69,0,.368,0,.524.155.526.518q0,.817,0,1.634c0,.349-.158.507-.507.508q-1.718,0-3.435,0a.435.435,0,0,1-.493-.493q-.006-.845,0-1.69a.431.431,0,0,1,.48-.479c.582,0,1.164,0,1.745,0Zm-1.322.9v.856h2.626v-.856Z",
    transform: "translate(-262.67 -492.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_785",
    "data-name": "Caminho 785",
    d: "M281.492,533c.573,0,1.145,0,1.717,0a.436.436,0,0,1,.5.488q.007.845,0,1.69a.431.431,0,0,1-.475.484q-1.745,0-3.49,0a.429.429,0,0,1-.472-.485q-.007-.845,0-1.69c0-.327.165-.482.5-.484C280.347,533,280.92,533,281.492,533Zm-1.321,1.756h2.63V533.9h-2.63Z",
    transform: "translate(-262.678 -524.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_786",
    "data-name": "Caminho 786",
    d: "M281.494,568.01c.563,0,1.126,0,1.69,0,.37,0,.526.152.528.515q0,.817,0,1.634c0,.35-.158.51-.5.511q-1.717,0-3.435,0a.433.433,0,0,1-.5-.488q-.006-.845,0-1.69c0-.327.165-.483.5-.485C280.349,568.008,280.921,568.01,281.494,568.01Zm1.32.9h-2.63v.856h2.63Z",
    transform: "translate(-262.68 -555.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_787",
    "data-name": "Caminho 787",
    d: "M281.5,605.67c-.563,0-1.126,0-1.69,0-.372,0-.528-.151-.53-.513q0-.817,0-1.634c0-.363.157-.513.528-.514q1.7,0,3.407,0c.343,0,.5.162.5.513q0,.817,0,1.634c0,.363-.157.515-.527.516C282.626,605.672,282.063,605.67,281.5,605.67Zm1.323-1.757h-2.636v.848h2.636Z",
    transform: "translate(-262.685 -587.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_788",
    "data-name": "Caminho 788",
    d: "M134.863,604.745c0-.424,0-.849,0-1.273a.434.434,0,0,1,.263-.445.442.442,0,0,1,.528.116c.424.424.851.845,1.271,1.273a.441.441,0,0,1-.007.7c-.413.422-.835.835-1.251,1.254a.456.456,0,0,1-.8-.355C134.868,605.594,134.863,605.169,134.863,604.745Z",
    transform: "translate(-132.642 -587.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_789",
    "data-name": "Caminho 789",
    d: "M166.379,604.809c0,.424,0,.848,0,1.273a.444.444,0,1,1-.884-.008q-.005-1.273,0-2.545c0-.325.172-.512.45-.512s.438.193.439.52c0,.424,0,.848,0,1.273Z",
    transform: "translate(-160.232 -587.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_790",
    "data-name": "Caminho 790",
    d: "M179.52,604.807c0,.424,0,.848,0,1.273,0,.309-.165.495-.43.5-.282,0-.454-.181-.455-.5q0-1.273,0-2.545c0-.309.165-.494.431-.5.282-.006.451.178.453.505C179.522,603.959,179.52,604.383,179.52,604.807Z",
    transform: "translate(-172.057 -587.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_791",
    "data-name": "Caminho 791",
    d: "M132.713,462.934c.62,0,1.239.008,1.858,0,.268-.005.375.1.352.362-.008.092,0,.185,0,.277a.226.226,0,0,1-.258.253h-3.911a.233.233,0,0,1-.268-.272c0-.018,0-.037,0-.055-.011-.558-.011-.558.537-.558h1.692Z",
    transform: "translate(-128.708 -461.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_792",
    "data-name": "Caminho 792",
    d: "M314.739,463.857c-.461,0-.464,0-.464-.466,0-.395.025-.421.4-.422.488,0,.491,0,.491.44S315.153,463.856,314.739,463.857Z",
    transform: "translate(-294.132 -461.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_793",
    "data-name": "Caminho 793",
    d: "M176.934,549.183c-.712,0-1.424,0-2.136,0-.368,0-.523-.159-.523-.521a2.663,2.663,0,0,1,5.266-.488,2.753,2.753,0,0,1,.055.466c.011.383-.146.542-.526.543C178.358,549.184,177.646,549.183,176.934,549.183Zm1.682-.895a1.724,1.724,0,0,0-3.354,0Z",
    transform: "translate(-168.155 -536.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_794",
    "data-name": "Caminho 794",
    d: "M188.73,515.507a1.331,1.331,0,1,1-1.334,1.335A1.315,1.315,0,0,1,188.73,515.507Zm.008.892a.457.457,0,0,0-.45.435.439.439,0,1,0,.45-.435Z",
    transform: "translate(-179.95 -508.5)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainings);
export default __webpack_public_path__ + "static/media/trainings.c6db57dea80d6eb0bdeb5b65ef99a3f9.svg";
export { ForwardRef as ReactComponent };